export default {
  components_Sunday: '日',
  components_Monday: '一',
  components_Tuesday: '二',
  components_Wednesday: '三',
  components_Thursday: '四',
  components_Friday: '五',
  components_Saturday: '六',
  components_browser_not_support_canvas: '您的瀏覽器不支持canvas標簽。',
  components_expression: '表情',
  components_make_comment: '我來評一句',
  components_reply: '回復{name}:',
  components_reply_btn:'回復',
  components_year_mouths: "YYYY年 MM月",
  components_all_loaded: '已全部加載完畢',
  components_Loading: '正在加載',
  components_current_page_size:'找到{total}條記錄, 顯示{start}到{end}條',
  components_many_attempts:'嘗試次數過多，請重新驗證',
  components_many_refresh:'刷新次數過多，請重新驗證',
  components_upload_files_empty:'上傳文件為空，請重新選擇',
  components_file_size_limit:"單個文件不能超過{limitSize}M，請重新選擇",
  components_upload_time_out:'上傳超時！',
  components_net_error:"網絡錯誤！",
  components_uploading:"上傳中...",
  components_uploadNumLimit:"最多支持上傳{limit}個文件",
  components_most_num_limit:'一次最多上傳{limit}個文件',
  components_single_num_limit:'單次最多上傳{limit}個文件，請重新選擇',
  components_upload_failed:'文件上傳失敗！',
  components_files_time_out:'文件上傳超時！',
  components_select_file:'選擇文件',
  components_limit_num_types:'可上傳不超過{limit}個附件，格式支持：word、excel、ppt、pdf、jpg、png，每個文件大小為{limitSize}M以內。',
  components_please_upload_again:'上傳文件為空，請重新上傳',
  components_file_format_match:'文件格式不符，請檢查後重試',
  components_limit_size_tip:'上傳文件不得大於{limitSize}M，請重新上傳',

}
